/**
 * Theme Requirements Aggregation for Amc Homeestead
 * 
 * Extends the base theme-homestead theme requirements with Amc Homeestead specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { mergeComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-theme-homestead/requirements';

/**
 * Amc Homeestead component requirement overrides.
 * Add requirements for any override components here.
 */
const amchomeesteadOverrides: Record<string, ComponentRequirements> = {
  // The overridden Header renders the pet policy in its "Community Info" pop-up
  // (as a structured bullet list built from the pet data fields). The Header is
  // global, so those fields must be guaranteed fetched on every page — merge in
  // PetPolicy's data-token requirements (property_max_pets, _monthly_pet_rent,
  // _pet_restrictions, deposit/fee/weight, allows_cats/dogs) on top of the
  // base Header requirements.
  Header: mergeComponentRequirements([baseRequirements.Header, baseRequirements.PetPolicy]),
};

/**
 * All component requirements for the Amc Homeestead theme.
 * Inherits from theme-homestead theme and overrides with Amc Homeestead components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...amchomeesteadOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
